import { useEffect, useContext, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import FormatPrice from "../helper/FormatPrice";
import { Button } from "../components/Button";
import axios from "../helper/axios";
import "./SingleProduct.css";
import ZoomableImage from "../components/ZoomableImage";

const SingleProduct = () => {
  const { addToCart, cartItems, fetchCartItems } = useContext(CartContext);
  const { token } = useContext(AuthContext);
  const [singleProduct, setSingleProduct] = useState({});
  const [isSingleLoading, setIsSingleLoading] = useState(true);
  const [isAddedToCart, setIsAddedToCart] = useState(false);

  const loggedInUser = localStorage.getItem("token");
  const loggedInUserId = localStorage.getItem("userId");

  const { sku } = useParams();
  const navigate = useNavigate();

  // useEffect(() => {}, []);

  useEffect(() => {
    const fetchSingleProduct = async () => {
      const category = {
        category: ["jewelry"],
        product_sku: sku,
      };

      try {
        const response = await axios.post("/product_read", category);
        // const response = await axios.post('/product_read', { product_sku: sku });
        const data = response.data.data;
        // console.log(data[0].product_image[0], "data");
        setSingleProduct(data[0]);
        console.log("singleProduct", singleProduct);
        setIsSingleLoading(false);
      } catch (error) {
        console.error(error);
        setIsSingleLoading(false);
      }
    };

    fetchSingleProduct();
    fetchCartItems();
  }, [sku]);

  const handleAddToCart = async () => {
    const product = {
      sku: singleProduct.product_sku,
      product_id: singleProduct.product_id,
      name: singleProduct.product_name,
      price: singleProduct.product_price,
      image: singleProduct.product_image.toString().split(",")[0],
      cut: singleProduct.cut_name,
      color: singleProduct.color_name,
      metal: singleProduct.metal_name,
      shape: singleProduct.shape_name,
      style: singleProduct.style_name,
      clarity: singleProduct.clarity_name,
      carat: singleProduct.carat,
    };

    const userId = localStorage.getItem("userId");

    if (loggedInUser) {
      // Check if the product is already in the cart
      const existingCartItem = cartItems.find(
        (item) => item.product_id === product.product_id
      );
      // User is logged in, add product to the backend
      if (existingCartItem) {
        // Product is already in the cart, call the update_item_in_cart API
        const updateItemInCart = {
          cart_id: existingCartItem.cart_id,
          product_id_fk: product.product_id,
        };
        try {
          await axios.put("/update_item_in_cart", updateItemInCart);
          console.log("Product Updated in Cart Successfully");
          fetchCartItems(); // Assuming this function fetches the updated cart items
          setIsAddedToCart(true);
        } catch (error) {
          console.error(error);
        }
      } else {
        // Product is not in the cart, add it to the backend
        try {
          await addToCart(product, userId);
          fetchCartItems();
          setIsAddedToCart(true);
        } catch (error) {
          console.error(error);
        }
      }
    } else {
      // User is not logged in, add product to localStorage
      addToCart(product);
      // setCartItems((prevItems) => [...prevItems, { ...product }]);
      // alert("Product Added to Temporary Cart");
      setIsAddedToCart(true);
    }
  };

  const [mainImage, setMainImage] = useState(null);

  useEffect(() => {
    if (singleProduct.product_image && singleProduct.product_image.length > 0) {
      setMainImage(singleProduct.product_image[0]);
    }
  }, [singleProduct.product_image]);

  const goToCart = () => {
    navigate("/cart");
  };

  // const { addToCart } = useContext(CartContext);
  // const [singleProduct, setSingleProduct] = useState({});
  // const [added, setAdded] = useState(false);

  // const { sku } = useParams();

  // useEffect(() => {
  //   const fetchSingleProduct = async () => {
  //     const category = { category: ["Diamond", "jewelry"], product_sku: sku };

  //     try {
  //       const response = await axios.post("/product_read", category);
  //       const data = response.data.data;
  //       setSingleProduct(data[0]);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   fetchSingleProduct();
  // }, [sku]);

  // const handleAddToCart = () => {
  //   const product = {
  //     sku: singleProduct.product_sku,
  //     id: singleProduct.product_id,
  //     name: singleProduct.product_name,
  //     price: singleProduct.product_price,
  //     image: singleProduct.product_image.toString().split(',')[0],
  //     cut: singleProduct.cut_name,
  //     color: singleProduct.color_name,
  //     metal: singleProduct.metal_name,
  //     shape: singleProduct.shape_name,
  //     style: singleProduct.style_name,
  //     clarity: singleProduct.clarity_name,
  //     carat: singleProduct.carat,
  //   };
  //   addToCart(product);
  //   setAdded(true);
  //   alert("Added to Cart");
  // };

  // const [mainImage, setMainImage] = useState(null);

  // useEffect(() => {
  //   if (singleProduct.product_image && singleProduct.product_image.length > 0) {
  //     setMainImage(singleProduct.product_image[0]);
  //   }
  // }, [singleProduct.product_image]);

  return (
    <div className="">
      <div className="container-fluid">
        <div className="row">
          <div className="page-banner hero-container">
            <div className="banner-content">
              <h1>Product</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="product-data container my-5">
        {singleProduct.category_name === "Diamond" && (
          <div className="row">
            <div className="col-sm-1">
              {singleProduct.product_image &&
                singleProduct.product_image.map((slide) => (
                  <>
                    <div key={slide.product_id}>
                      <button
                        className="btn text-start"
                        onMouseOver={() => setMainImage(slide)}
                      >
                        <img src={slide} width={70} height={70} />
                      </button>
                    </div>
                  </>
                ))}
            </div>
            <div className="col-sm-6">
              <ZoomableImage
                className="cards__item__img"
                alt="Diamond"
                imageUrl={mainImage}
                zoomWidth={1500}
                zoomHeight={1500}
              />
            </div>
            <div className="col-sm-4">
              <div className="product-title">{singleProduct.product_name}</div>
              <div className="product-detail">
                <b>Shape</b>: <span>{singleProduct.shape_name}</span> <br />
                <b>Clarity</b>: <span>{singleProduct.clarity_name}</span> <br />
                <b>Color</b>: <span>{singleProduct.color_name}</span> <br />
              </div>
              <div className="product-detail">
                <span> {singleProduct.carat} Carat</span> |{" "}
                <span>{singleProduct.cut_name} Cut</span>{" "}
                {/* <span>{singleProduct.shape_name} Shape</span> */}
              </div>

              <div className="product-price">
                <FormatPrice price={singleProduct.product_price + 0} />
              </div>
              <div className="hero-btn1 mt-4 row">
                <div className="col-sm-4">
                  <Button
                    className="btns"
                    buttonStyle="btn__primary"
                    buttonSize="btn__medium"
                    onClick={handleAddToCart}
                    disabled={isAddedToCart}
                  >
                    {singleProduct.category_name === "Diamond"
                      ? "Select Setting"
                      : "Add to Cart"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {singleProduct.category_name === "jewelry" && (
          <div className="row">
            <div className="col-sm-1">
              {singleProduct.product_image &&
                singleProduct.product_image.map((slide, index) => (
                  <>
                    <div key={slide.product_id}>
                      <button
                        className="btn text-start"
                        onMouseOver={() => setMainImage(slide)}
                      >
                        <img src={slide} width={70} height={70} />
                      </button>
                    </div>
                  </>
                ))}
            </div>
            <div className="col-sm-6">
              <ZoomableImage
                className="cards__item__img"
                alt="Diamond"
                imageUrl={mainImage}
                zoomWidth={1500}
                zoomHeight={1500}
              />
            </div>
            <div className="col-sm-4">
              <div className="product-title">{singleProduct.product_name}</div>
              <div className="product-detail">
                <b>Metal</b>: <span>{singleProduct.metal_name}</span> <br />
                <b>Setting</b>:{" "}
                <span>{singleProduct.product_settings_name}</span> <br />
                <b>Type</b>: <span>{singleProduct.product_type_name}</span>{" "}
                <br />
              </div>
              <div className="product-detail">
                <span> {singleProduct.carat} Carat</span> |{" "}
                <span>{singleProduct.style_name} Style</span> |{" "}
                <span>{singleProduct.shape_name} Shape</span>
              </div>

              <div className="product-price">
                <FormatPrice price={singleProduct.product_price + 0} />
              </div>
              <div className="hero-btn1 mt-4 row">
                {/* <div className="col-sm-4">
                  <Button
                    className="btns"
                    buttonStyle="btn__primary"
                    buttonSize="btn__medium"
                    onClick={handleAddToCart}
                  >
                    {isAddedToCart
                      ? singleProduct.category_name === "jewelry" &&
                        "Added to Cart"
                      : singleProduct.category_name === "jewelry"
                      ? "Add to Cart"
                      : "Select Setting"}
                  </Button>
                </div>
                {isAddedToCart && (
                  <div className="col-4">
                    <Button
                      className="btns"
                      buttonStyle="btn__primary"
                      buttonSize="btn__medium"
                      onClick={goToCart}
                    >
                      {singleProduct.category_name === "jewelry" &&
                        "Go To Cart"}
                    </Button>
                  </div>
                )} */}
                {isAddedToCart ? (
                  <Button
                    className="btns"
                    buttonStyle="btn__primary"
                    buttonSize="btn__medium"
                    onClick={goToCart}
                  >
                    {singleProduct.category_name === "jewelry"
                      ? "Go To Cart"
                      : "Select Setting"}
                  </Button>
                ) : (
                  <Button
                    className="btns"
                    buttonStyle="btn__primary"
                    buttonSize="btn__medium"
                    onClick={handleAddToCart}
                  >
                    {singleProduct.category_name === "jewelry"
                      ? "Add to Cart"
                      : "Select Setting"}
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleProduct;
